'use strict';

module.exports = function (output) {
    for (var i = 1; i < arguments.length; i++) {
        var input = arguments[i];
        for (var k in input) {
            output[k] = input[k];
        }
    }
    return output;
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/mapbox-gl-style-spec/lib/util/extend.js
 ** module id = 372
 ** module chunks = 0
 **/